import axios from 'axios';

const apiClient = axios.create({
    baseURL: window.RUNTIME_CONFIG.REACT_APP_API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

const instance = axios.create();
instance.interceptors.request.use((config) => {
    console.log('Request URL:', config.url);  // Log the URL of each request
    return config;
});

// Function to handle refreshing the token
const refreshToken = async () => {
    try {
        const response = await apiClient.post('/refreshToken', {
            refreshToken: localStorage.getItem('refreshToken'),
        });
        return response.data.accessToken;
    } catch (error) {
        console.error("Refresh token failed", error);
        throw error;
    }
};

// Interceptor to add JWT token to each request
apiClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('accessToken');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Interceptor to handle expired tokens and refresh them
apiClient.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response.status === 401 && error.response.data && error.response.data.error === 'Token Expired' && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                const newToken = await refreshToken();

                // Update token in localStorage
                localStorage.setItem('accessToken', newToken);

                // Set new Authorization header
                apiClient.defaults.headers['Authorization'] = `Bearer ${newToken}`;
                originalRequest.headers['Authorization'] = `Bearer ${newToken}`;

                // Retry original request with new token
                return apiClient(originalRequest);
            } catch (error) {
                // Handle refresh token failure (e.g., redirect to login)
                console.error("Token refresh failed, redirecting to login...");
                return Promise.reject(error);
            }
        }

        return Promise.reject(error);
    }
);

export default apiClient;
